import { OperatorRole, LoginType, LoginNameType } from 'model/operator';

export const LOGIN_TYPE_LIST = [
  {
    value: LoginType.qq,
    label: 'QQ',
    login_name_type: LoginNameType.qq,
  },
  {
    value: LoginType.wx,
    label: '微信',
    login_name_type: LoginNameType.wx,
  },
];

export const OPERATOR_ROLE_MAP: Record<OperatorRole, string> = {
  [OperatorRole.admin]: '管理员',
  [OperatorRole.operator]: '运营人员',
};
